import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import CustomerInfo from './CustomerInfo'
import { CUSTOMER_NAME_QUERY } from './detail/queries'

const CustomerShowPage = ({ match }) => {
    const { id } = match.params

    useEffect(() => { document.title = 'Customer Info | OSH CRM' }, [])

    const { data } = useQuery(CUSTOMER_NAME_QUERY, { variables: { customerNo: id } })
    const customer = data && data.customer
    const label = customer
        ? `${customer.customerNo} · ${customer.fullName || ''}`.trim().replace(/·\s*$/, '').trim()
        : id
    // A customer may belong to several companies. The breadcrumb links the first
    // company; when there is more than one, it also carries a dropdown (`menu`)
    // listing every company so the user can jump to any of them.
    const companies = (customer && customer.companies) || []
    const first = companies[0]
    const companyCrumb = first
        ? {
            path: `/companies/${first.id}`,
            name: first.name,
            menu: companies.length > 1
                ? companies.map((c) => ({ path: `/companies/${c.id}`, name: c.name }))
                : undefined
        }
        : null

    const breadcrumbs = [
        { path: '/customers', name: 'ลูกค้าและบริษัท' },
        ...(companyCrumb ? [companyCrumb] : []),
        { path: `/customers/${id}`, name: label }
    ]

    return (
        <Layout>
            <LayoutContentWrapper breadcrumbs={breadcrumbs}>
                <ContentLayout>
                    <CustomerInfo customerId={id} />
                </ContentLayout>
            </LayoutContentWrapper>
        </Layout>
    )
}

export default CustomerShowPage
